import { MouseEvent } from 'react';
import { AttioSortDirection, SortCriteria } from 'dashboard409a/common/constants/analyst-dashboard';
import { ModelStatus as ModelStatusEnum } from 'dashboard409a/pages/Workboard/common/types';
import { ModelWithValuationData } from '../../services/models.types';

interface ActionOptions {
  label: string;
  callback: () => void;
  isActive: boolean;
}

export interface ModelsTableHeadColumn {
  id: string;
  label: string;
  isSortable?: boolean;
  align?: 'left' | 'right' | 'center';
  disablePadding?: boolean;
  component?: string;
  options?: ActionOptions[];
}

export interface ModelsTableHeadProps {
  order: AttioSortDirection;
  orderBy: string;
  sortCriteria?: SortCriteria[];
  onRequestSort: (event: MouseEvent<unknown>, property: string, addToSort?: boolean) => void;
  columns: ModelsTableHeadColumn[];
  columnWidths?: Record<string, number>;
  onColumnWidthChange?: (columnId: string, newWidth: number) => void;
}

export interface ModelsTableRowProps {
  modelRow: ModelWithValuationData;
  onRowClick: (row: ModelWithValuationData, event: React.MouseEvent<HTMLTableRowElement>) => void;
  onNoteSave?: (fulfillmentId: number, noteContent: string, currentNote?: string) => Promise<void>;
  onStatusUpdate?: (modelId: number, newStatus: number) => void;
  isNoteLoading?: boolean;
  noteError?: string | null;
}

export interface ModelsTableProps {
  paletteVersion?: number;
  tableKey?: number;
  isLoading: boolean;
  rows: ModelWithValuationData[];
  onNoteSave: (fulfillmentId: number, noteContent: string, currentNote?: string) => Promise<void>;
  onStatusUpdate: (modelId: number, newStatus: number) => void;
  orderBy: string;
  order: AttioSortDirection;
  sortCriteria?: SortCriteria[];
  onRequestSort: (event: React.MouseEvent<unknown>, property: string, addToSort?: boolean) => void;
  isNoteLoading?: boolean;
  noteError?: string | null;
  onRowClick: (model: ModelWithValuationData, event: React.MouseEvent<HTMLTableRowElement>) => void;
  onFiltersChange?: (filters: {
    searchParam: string;
    searchStatus: string;
    fromDate: Date | null;
    toDate: Date | null;
    userIds: number[];
  }) => void;
  columnWidths?: Record<string, number>;
  onColumnWidthChange?: (columnId: string, newWidth: number) => void;
}

export interface ModelsStatusOption {
  value: string;
  label: string;
}
export const MODEL_FILTER_TYPES = {
  CURRENT: 'current',
  PAST: 'past',
  UNASSIGNED: 'unassigned',
  ALL: 'all',
} as const;

export type ModelFilterType = (typeof MODEL_FILTER_TYPES)[keyof typeof MODEL_FILTER_TYPES];

export interface FilterTypeSelection {
  current: boolean;
  past: boolean;
  unassigned: boolean;
  all: boolean;
}

// Note: WAITING is now handled via the is_waiting field, not as a status option
export const modelsStatusOptions: ModelsStatusOption[] = [
  { value: ModelStatusEnum.DRAFT, label: 'Draft' },
  { value: ModelStatusEnum.REVIEW, label: 'Review' },
  { value: ModelStatusEnum.IN_PROCESS_SCALAR_USA, label: 'In-process ScalarUSA' },
  { value: ModelStatusEnum.FINAL, label: 'Final' },
  { value: ModelStatusEnum.REVIEW_FINAL, label: 'Review Final' },
  { value: ModelStatusEnum.COMPLETE, label: 'COMPLETE' },
];
